import { createFileRoute, Link, ToPathOption } from "@tanstack/react-router"
import { GridList, GridListItem } from "react-aria-components"
import { useTranslation } from "react-i18next"

import { IconName } from "@/assets/icons"
import Icon from "@/globalComponents/atoms/Icon"
import { router } from "@/router"
import { cn } from "@/utilities/etc"
import { useTheme } from "@/utilities/hooks/useTheme"

import styles from "./index.module.css"

export const Route = createFileRoute("/_authenticated/account/")({
  staticData: {
    pageName: "Account",
  },
  component: RouteComponent,
})

interface MenuItem {
  title: string
  iconName: IconName
  to: ToPathOption<typeof router>
}

function RouteComponent() {
  const { t } = useTranslation(["common"])
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const { scannedArea } = useTheme()

  const hasFlexPurchase = scannedArea?.theme.welcome.flowCard.flows.some(
    (flow) => flow.type === "flexPurchase"
  )

  const menuItems: MenuItem[] = [
    {
      title: t("account.personalInfo.label"),
      iconName: "person",
      to: "/account/personal-information",
    },
    {
      title: t("account.vehicles.label"),
      iconName: "car",
      to: "/account/vehicles",
    },
    ...(hasFlexPurchase
      ? ([
          {
            title: t("myPasses.label", { ns: "park" }),
            iconName: "pass",
            to: "/account/passes",
          },
        ] as const)
      : []),
    {
      title: t("account.savedPaymentMethods.label"),
      iconName: "creditCard",
      to: "/account/saved-payment-methods",
    },
    {
      title: t("account.updatePassword.label"),
      iconName: "passwordInput",
      to: "/account/update-password",
    },
  ]

  return (
    <GridList
      items={menuItems}
      className={styles.linkList}
      selectionBehavior="replace"
      aria-label={t("account.linkListLabel")}
    >
      {(item) => (
        <GridListItem
          id={item.to}
          key={item.to}
          textValue={item.title}
          onAction={() => navigate({ to: item.to, search })}
        >
          <Link
            to={item.to}
            search={search}
            className={cn(styles.links, "bold")}
          >
            <div className={styles.linkIcon}>
              <Icon name={item.iconName} />
            </div>
            {item.title}
            <Icon name="chevronRight" />
          </Link>
        </GridListItem>
      )}
    </GridList>
  )
}
